import axios from "axios";
import store from "../store";
import { authActions } from "../actions/auth";

const axiosInstance = axios.create();

// Request interceptor to add auth token
axiosInstance.interceptors.request.use(
  (config) => {
    const state = store.getState();
    const token = state.authReducer.signToken;

    if (token && typeof token === "string") {
      config.headers.Authorization = `JWT ${token}`;
    } else if (token && token.access) {
      config.headers.Authorization = `JWT ${token.access}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor - only logs errors, doesn't auto-logout
// The user must explicitly log out via the menu
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const status = error.response?.status;

    // Try token refresh only if we have a refresh token (local JWT)
    if (status === 401 && !originalRequest._retry) {
      const state = store.getState();
      const token = state.authReducer.signToken;
      const refreshToken =
        token && typeof token === "object" ? token.refresh : null;

      if (refreshToken) {
        originalRequest._retry = true;
        try {
          const apiUrl = process.env.REACT_APP_API_URL;
          const response = await axios.post(
            `${apiUrl}/auth/api/token/refresh`,
            { refresh: refreshToken }
          );

          const newToken = {
            access: response.data.access,
            refresh: response.data.refresh || refreshToken,
          };

          store.dispatch(authActions.getToken(newToken));
          originalRequest.headers.Authorization = `JWT ${newToken.access}`;
          return axiosInstance(originalRequest);
        } catch (refreshError) {
          console.warn("Token refresh failed:", refreshError.message);
          // Don't auto-logout - let the user do it. Just propagate the error.
        }
      }
      // For SUZA tokens (no refresh) or refresh failure, just log the issue
      console.warn("Authentication failed. Please log in again if needed.");
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
